import { PageProps } from '@wix/design-system';
import React, { ReactNode } from 'react';
import { useCollectionPageChild } from '../../hooks/useCollectionPageChild';
import { CollectionPageHeader } from '../CollectionPageHeaderNew';
import { InfiniteScrollPage } from '../PageWrapper';
import { CollectionPageContent } from '../CollectionPageContent';
import { observer } from 'mobx-react-lite';

export interface CollectionPageProps extends PageProps {
  children?: ReactNode;
}

function _CollectionPage({ children, ...rest }: CollectionPageProps) {
  const childrenArr = useCollectionPageChild(children);

  return <InfiniteScrollPage {...rest}>{childrenArr}</InfiniteScrollPage>;
}

_CollectionPage.Header = CollectionPageHeader;
_CollectionPage.Content = CollectionPageContent;

_CollectionPage.displayName = 'CollectionPage';

export const CollectionPage = observer(_CollectionPage);
